<template>
  <div class="row">
    <div class="col-3 d-flex flex-column align-items-center">
      <div
        class="placeholder bg-soft-light rounded-circle circle-sm"
        aria-hidden="true"
      ></div>
    </div>
    <div class="col-8">
      <div class="placeholder-glow" aria-hidden="true">
        <div class="placeholder col-12 placeholder-xs" aria-hidden="true"></div>
      </div>
      <div class="placeholder-glow" aria-hidden="true">
        <div class="placeholder col-12 placeholder-xs" aria-hidden="true"></div>
      </div>
      <div class="placeholder-glow" aria-hidden="true">
        <div class="placeholder col-12 placeholder-xs" aria-hidden="true"></div>
      </div>
      <div class="placeholder-glow" aria-hidden="true">
        <div class="placeholder col-6" aria-hidden="true"></div>
      </div>
      <div class="placeholder-glow" aria-hidden="true">
        <div class="placeholder col-8 placeholder-sm" aria-hidden="true"></div>
      </div>
    </div>
  </div>
  <a
    role="button"
    class="btn btn-outline-soft-light placeholder mt-3 col-12"
    aria-hidden="true"
  ></a>
</template>
